import { render, staticRenderFns } from "./Hall.vue?vue&type=template&id=afdbda3c&scoped=true"
import script from "./Hall.vue?vue&type=script&lang=js"
export * from "./Hall.vue?vue&type=script&lang=js"
import style0 from "./Hall.vue?vue&type=style&index=0&id=afdbda3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdbda3c",
  null
  
)

export default component.exports